/* Automatski 5% popust za korisnike PWA aplikacije - dodato 03.08.2026 */
(function(){
  try{
    var isApp = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
    if(!isApp){ return; }
    if(!sessionStorage.getItem('shAppDisc')){
      sessionStorage.setItem('shAppDisc','1');
      try{ fetch('/discount/APLIKACIJA5', { credentials: 'same-origin' }).catch(function(){}); }catch(e){}
      if(document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', function(){ setTimeout(shAppMsg, 800); });
      } else {
        setTimeout(shAppMsg, 800);
      }
    }
    function shAppMsg(){
      if(!document.body || document.getElementById('sh-app-msg')){ return; }
      var w = document.createElement('div');
      w.id = 'sh-app-msg';
      w.setAttribute('style', 'position:fixed;left:12px;right:12px;bottom:16px;z-index:2147483600;max-width:460px;margin:0 auto;background:#121212;color:#fff;padding:14px 42px 14px 16px;border-radius:14px;font-family:Lato,-apple-system,sans-serif;font-size:14px;line-height:1.45;box-shadow:0 12px 30px rgba(0,0,0,.32);text-align:center');
      w.innerHTML = '🎉 Dobili ste <strong>5% popusta</strong> jer kupujete preko aplikacije! Popust se automatski primenjuje na plaćanju.';
      var x = document.createElement('button');
      x.textContent = '×';
      x.setAttribute('style', 'position:absolute;top:8px;right:12px;background:none;border:0;color:#fff;font-size:20px;line-height:1;cursor:pointer;opacity:.85');
      x.onclick = function(){ if(w.parentNode){ w.parentNode.removeChild(w); } };
      w.appendChild(x);
      document.body.appendChild(w);
      setTimeout(function(){ if(w.parentNode){ w.style.transition='opacity .6s'; w.style.opacity='0'; setTimeout(function(){ if(w.parentNode){ w.parentNode.removeChild(w); } }, 650); } }, 9000);
    }
  }catch(e){}
})();
